import { ClientDetailsFormData } from '~admin/view/components/details/client-details/client-dropdowns/client-name-dropdown.component';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';

/**
 * Transforms EventClientDetailsFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventClientDetailsRequest = (
  values: ClientDetailsFormData,
): Pick<EventProfileCreateRequest, 'clientId'> => {
  const { clientId } = values;

  return {
    clientId,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-client-details-request.helper.ts